// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__tDTu7","nodata":"topTable_nodata__3cDki"};